import { TOOLTIP_WIDTH_EXPANDED } from '@frontend/components/src/components/overlay/tooltip';

import { DRAG_SUMMARY_PARTS } from './dragSummaryParts';
import type { DragSummaryStyleConfig } from './types';

export const DRAG_SUMMARY_STYLE_CONFIG: DragSummaryStyleConfig = {
  parts: DRAG_SUMMARY_PARTS,
  baseStyle: {
    container: {
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'stretch',
      width: 'auto',
      maxWidth: TOOLTIP_WIDTH_EXPANDED,
      py: 1,
      px: 1.5,
      borderRadius: 'md',
      boxShadow: 'popover',
      fontSize: 'md',
      lineHeight: 'md',
      overflowWrap: 'anywhere',
      color: 'feature.onInteraction',
      backgroundColor: 'interaction.main',
    },
    draggedItemDescription: {
      fontWeight: 'medium',
    },
  },
};
